<ng-diagram-node-resize-adornment>
  <div
    class="group-node normal-node"
    ngDiagramGroupHighlighted
    ngDiagramNodeSelected
    [attr.data-content-id]="node()?.data?.word.id"
    [attr.data-node-id]="node()?.id"
    [attr.data-node-type]="'word'"
    [node]="node()"
  >
    <ng-diagram-port id="port-right" side="right" style="top: 30px" type="source" />

    <div class="group-node__header">
      <mat-icon class="ddc-content-icon">{{ icon() }}</mat-icon>
      <span class="group-node__title">{{ title() }}</span>
    </div>
    <div class="group-node__content">
      <div class="content-row">
        <ddc-country-flag [ddc_lng]="node()?.data?.word.language"></ddc-country-flag>
        <span class="content-word">{{ node()?.data?.word.word }}</span>
      </div>
    </div>
  </div>
</ng-diagram-node-resize-adornment>
